import { Controller } from '@hotwired/stimulus'

// Manages a polymorphic chat tab inside the interact pane.
//
// Listens for the custom turbo:after-stream-render event (dispatched by
// application.js after each Turbo Stream render completes) and scrolls the
// message list to the bottom so the newest message is visible.
//
// Targets:
//   messages  – the scrollable message list container
//
// Values:
//   lastVisit  String  – ISO timestamp of the user's last visit (may be blank)
export default class extends Controller {
  static targets = ['messages']
  static values = { lastVisit: String }

  // Called via data-action="turbo:after-stream-render@document->chat#scrollToBottom"
  // Fires after each Turbo Stream render (broadcast append or direct HTTP stream).
  // DOM is already updated at this point so no requestAnimationFrame needed.
  scrollToBottom () {
    if (!this.hasMessagesTarget) return
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }
}
